import {useRestaurants} from 'api/queries';
import {ProviderSliderWithSkeleton, ProviderTileList, Section} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import {ICustomerAddToFavoritesRequest, ICustomerMyFavoritesResponse, QueryKeyEnum} from 'types';

interface IProps {
  locale: string;
  myFavorite: ICustomerMyFavoritesResponse[];
  onEditFavorite: (data: ICustomerAddToFavoritesRequest) => void;
  coordinates: string;
}

export const NewRestaurantSection: FC<IProps> = ({locale, onEditFavorite, myFavorite, coordinates}) => {
  const {t} = useTranslation();

  const {data: newRestaurants, isLoading: isLoadingNewRestaurants} = useRestaurants(
    [QueryKeyEnum.RESTAURANT_BY_FILTER, {filters: 'new', only_working: true}, locale, coordinates],
    {
      limit: 0,
      filters: 'new',
      only_working: true,
    },
    {},
  );

  const isShowBlock = !!newRestaurants?.count || isLoadingNewRestaurants;

  return (
    <>
      {isShowBlock && (
        <Section
          title={t('NEW_RESTAURANTS_ON_STRAUS')}
          viewAllLabel={t('VIEW_ALL')}
          linkTo="/restaurants?filters=new"
          count={`${newRestaurants?.count ?? ''}`}
        >
          <ProviderSliderWithSkeleton conditionValue={isLoadingNewRestaurants}>
            <ProviderTileList
              myFavorite={myFavorite}
              onEditFavorite={onEditFavorite}
              data={newRestaurants?.results}
              isHorizontal
            />
          </ProviderSliderWithSkeleton>
        </Section>
      )}
    </>
  );
};
